import React, { useEffect, useState, useRef } from "react"
import { Sticky } from "./style.css"
import logo from "../../assets/Andar-Juntas_Alta.svg"

const HeaderSticky = () => {
  const imgEl = useRef(null)
  const [positionStyle, setPositionStyle] = useState({
    position: "absolute",
    top: "26%",
    left: 0,
    right: 0,
  })
  useEffect(() => {
    const isWindow =
      typeof window !== `undefined`
        ? window.addEventListener("scroll", handleScroll)
        : null
    const rect = imgEl.current.getBoundingClientRect()
    if (rect.width >= 680) {
      setPositionStyle({
        position: "absolute",
        top: "26%",
        left: 0,
        right: 0,
      })
    } else {
      setPositionStyle({
        position: "absolute",
        top: "50%",
        left: 0,
        right: 0,
      })
    }
  }, [])

  const handleScroll = () => {
    const rect = imgEl.current.getBoundingClientRect()
    if (rect.y >= 0 && rect.y <= 15) {
      setPositionStyle({
        position: "fixed",
        top: "18px",
        left: 0,
        right: 0,
      })
    } else if (rect.y <= -1) {
      setPositionStyle({
        position: "fixed",
        top: "18px",
        left: 0,
        right: 0,
      })
    }
  }

  return (
    <Sticky>
      <div className="titulo" ref={imgEl} style={positionStyle}>
        <img src={logo} alt="logo" />
      </div>
      <div className="iframe-sticky">
        <div className="wrapper">
          <iframe
            title="header video"
            id="vrudo"
            className="vrudo"
            src="https://rudo.video/vod/bLoWhJ?autoplay=1&volume=0&loop=1&stv=0"
            allowscriptaccess="always"
            allowFullScreen={true}
            webkitallowfullscreen="true"
            frameBorder="0"
            scrolling="no"
          />
        </div>
      </div>
    </Sticky>
  )
}

export default HeaderSticky
